import {
  colors,
  buttonGradients,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  space,
  opacity,
  boxShadow,
  utils
} from '../tokens'
import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    colors: typeof colors;
    buttonGradients: typeof buttonGradients;
    fontSizes: typeof fontSizes;
    fontWeights: typeof fontWeights;
    fonts: typeof fonts;
    lineHeights: typeof lineHeights;
    space: typeof space;
    opacity: typeof opacity;
    boxShadow: typeof boxShadow;
    utils: typeof utils;
  }
  
  interface ThemeOptions {
    colors?: typeof colors;
    buttonGradients?: typeof buttonGradients;
    fontSizes?: typeof fontSizes;
    fontWeights?: typeof fontWeights;
    fonts?: typeof fonts;
    lineHeights?: typeof lineHeights;
    space?: typeof space;
    opacity?: typeof opacity;
    boxShadow?: typeof boxShadow;
    utils?: typeof utils;
  }
}

export const ThemeTokens = {
  colors,
  buttonGradients,
  fontSizes,
  fontWeights,
  fonts,
  lineHeights,
  space,
  opacity,
  boxShadow,
  utils,
} 

export const ThatsTheTicketTheme = createTheme(ThemeTokens);

export const ThatsTheTicketDarkTheme = createTheme({
  ...ThemeTokens,
  palette: { background: { default: colors["neutral.950"] } },
});
